import { render, staticRenderFns } from "./_CreateOrganizationPopup.vue?vue&type=template&id=566a704c"
import script from "./_CreateOrganizationPopup.vue?vue&type=script&lang=ts"
export * from "./_CreateOrganizationPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports